// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"85841":"2956cf90692725214f3d","92888":"98244fc0a4e89fe30e6d"}[chunkId] + ".css";
};